import { ApiUserId } from 'api/types/ApiTypedId';

const openWebIdealistUserIdLocalStorageKey = 'SPOTIM_IDEALIST_USER_ID';

export function getOpenWebIdealistUserIdLocalStorageValue() {
  return localStorage.getItem(openWebIdealistUserIdLocalStorageKey);
}

export function setOpenWebIdealistUserIdLocalStorageValue(userId: ApiUserId) {
  localStorage.setItem(openWebIdealistUserIdLocalStorageKey, userId);
}

export function shouldClearOpenWebLocalStorageForUserId(
  userId: ApiUserId | undefined,
) {
  const openWebIdealistUserId = getOpenWebIdealistUserIdLocalStorageValue();
  return !openWebIdealistUserId || !userId || openWebIdealistUserId !== userId;
}

export function clearOpenWebLocalStorage() {
  localStorage.removeItem(openWebIdealistUserIdLocalStorageKey);

  Object.keys(localStorage).forEach((key) => {
    if (
      (key.startsWith('SPOT_') ||
        key.startsWith('SPOTIM_') ||
        key.startsWith('OW_') ||
        // Previously set when startSSO with userId as a second argument
        key.startsWith(`OWֹֹ_EXTERNAL`)) &&
      key !== 'OW_DRAFT_CONTENT'
    )
      localStorage.removeItem(key);
  });
}
